import { useState, useEffect } from 'react'

export const getCountdown = (targetDate) => {
  if (!targetDate) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true, totalMs: 0 }
  }
  const diff = Math.max(0, new Date(targetDate).getTime() - Date.now())
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    expired: diff <= 0,
    totalMs: diff,
  }
}

export const useCountdown = (targetDate) => {
  const [countdown, setCountdown] = useState(() => getCountdown(targetDate))

  useEffect(() => {
    if (!targetDate) return undefined
    const tick = () => setCountdown(getCountdown(targetDate))
    tick()
    const id = setInterval(tick, 1000)
    return () => clearInterval(id)
  }, [targetDate])

  return countdown
}
